import { useDisclosure } from "@mantine/hooks";
import { t } from "ttag";

import { ToolbarButton } from "metabase/common/components/ToolbarButton";
import SaveDashboardViewModal from "metabase/dashboard/containers/SaveDashboardViewModal";
import { useDashboardContext } from "metabase/dashboard/context";

export function SaveCurrentViewButton() {
  const [opened, { open, close }] = useDisclosure(false);
  const { dashboard } = useDashboardContext();

  return (
    <>
      <ToolbarButton
        icon="attachment"
        onClick={open}
        tooltipLabel={t`Save current view`}
        aria-label={t`Save current view`}
      />
      {opened && (
        <SaveDashboardViewModal
          collectionId={dashboard?.collection_id}
          onClose={close}
        />
      )}
    </>
  );
}
